// Dependencies
import { useState, useEffect, useRef, useCallback, useContext } from "react";
import _cx from "classnames";

// Components
import Modal from './Modal';

// Types
import { Types, Components } from '../utils/types';

// Utils
import {  } from '../utils/config'
import { getInfoIcon } from '../utils/helpers'

const Tooltip = ({label, children, className}: Components.Tooltip) => {

    const [isTooltipModalOpened, setIsTooltipModalOpened] = useState<boolean>(false);

    return (<>
        <Modal 
            id={'tooltip'}
            type="custom" 
            heading={label} 
            isOpened={isTooltipModalOpened}
            onClick={(e: any) => {
                if ( e.currentTarget.dataset.name === 'close' ) {
                    setIsTooltipModalOpened(false);
                }
            }}
        >
            {children}
        </Modal>
        <div tabIndex={0} className={_cx(className, 'wooptima-tooltip')} onKeyPress={(e) => e.key === 'Enter' && setIsTooltipModalOpened(true)} onClick={() => setIsTooltipModalOpened(true)}>
            {getInfoIcon('wooptima-tooltip__icon')}
            <span className="wooptima-tooltip__label">{label}</span>
        </div>
    </>) 
}
 
export default Tooltip; 